import { getToken } from '@/web-framework/api/token';
import store from '@/public/store';

const UserAPI = {
    findUserIdentities() {
        return Request.post('/admin/identity/search', { pageNo: -1 });
    },
    /**
     * 获取ip地址
     * @returns
     */
    getIp() {
        return Request.get('/admin/user/getIp');
    },
    /**
     * 获取学生数量
     */
    countUser(query) {
        return Request.post('/admin/user/countUser', query || {});
    },
    /**
     * 获取教师数量
     */
    countTeachers(query) {
        return Request.post('/admin/user/countTeachers', query || {});
    },
    /**
     * 获取新增用户数
     */
    countNewUsersOfDate(query) {
        return Request.post('/admin/user/countNewUsersOfDate', query || {});
    },
    /**
     * 获取在线用户数
     */
    countOnlineUsersOfDate(query) {
        return Request.post('/admin/user/countOnlineUsersOfDate', query || {});
    },
    countOnlineUsersInTwoHours(query) {
        return Request.post('/admin/user/countOnlineUsersInTwoHours', query || {});
    },

    /**
     * 比较当前用户身份与route网址路径是否一致，如果不一致，则需要切换身份
     */
    checkUserRoleFromRoute(routePath) {
        let currentRole = this.getUserRole();
        let roles = store.getters.roles;
        let found = null;
        if (roles && routePath) {
            for (let i = 0; i < roles.length; i++) {
                if (routePath.startsWith(roles[i].entrancePath)) {
                    found = roles[i];
                }
            }
        }
        if ((found && !currentRole) || (found && currentRole && found.id != currentRole.id)) {
            this.setUserRole(found);
        }
    },
    getUserRole() {
        let userRole = sessionStorage.getItem('currentUserRole');
        return userRole ? JSON.parse(userRole) : {};
    },
    setUserRole(role) {
        sessionStorage.setItem('currentUserRole', JSON.stringify(role));
    },
    haveRole() {
        let strRole = sessionStorage.getItem('currentUserRole');
        let userRole = strRole ? JSON.parse(strRole) : {};
        return userRole && userRole.id && userRole.id.length > 0;
    },
    /**
     * 确保用户信息已经缓存了
     */
    ensureUserInfoCached() {
        return new Promise((resolve, reject) => {
            let hasToken = getToken();
            if (hasToken && (!store.getters.user || !store.getters.user.id)) {
                // 存在token，但是未加载用户信息，则需要通过Token获取用户信息
                store
                    .dispatch('user/getUserInfo')
                    .then(reesult => {
                        resolve();
                    })
                    .catch(error => {
                        reject(error);
                    });
            } else {
                resolve();
            }
        });
    },
    /**
     * 获取当前登陆用户信息
     * @returns
     */
    getLoginedUserInfo(query) {
        return Request.get('/admin/userfaced/info?lvl=LV1', query);
    },
    /**
     * 搜索用户
     * @param {*} vm
     * @param {*} userIdentity
     * @param {*} pageNo
     * @returns
     */
    searchUsers(query) {
        return Request.post('/admin/user/search', query);
    },
    /**
     * @description: 根据关键字来查找用户
     * @param {*} query
     * @return {*}
     */    
    findUsersByKeyword(query){
        return Request.post('/admin/user/findUsersByKeyword', query);
    },
    /**
     * 根据id获取用户信息
     * @param {*} userId
     * @returns
     */
    getUserById(userId, params, lvl) {
        let level = lvl ? lvl : 'LV3';
        return Request.post(`/admin/user/getUserById/${userId}?lvl=${level}`, params || {});
    },

    /**
     * 新用户自主注册
     * @param {} data
     */
    regist(data) {
        return Request.post(`/auth/regist`, data);
    },
    /**
     * 创建用户
     * @param {*} user
     * @returns
     */
    createUser(roleId, user) {
        return Request.post(`/admin/user/create/${roleId}`, user);
    },

    /**
     * 保存用户信息
     * @returns
     */
    updateUser(user) {
        return Request.post('/admin/user/update', user);
    },

    /**
     * 删除用户
     * @param {*} userId
     * @returns
     */
    removeUser(userId) {
        return Request.delete(`/admin/user/delete/${userId}`);
    },

    /**
     * 批量删除用户
     * @param {} idArray
     * @returns
     */
    batchRemoveUsers(idArray) {
        return Request.post(`/admin/user/batchDelete`, idArray);
    },

    /**
     * 启用用户
     * @param {} userId
     * @returns
     */
    enableUser(userId) {
        return Request.get(`/admin/user/${userId}/enable`);
    },

    /**
     * 禁用用户
     * @param {*} userId
     * @returns
     */
    disableUser(userId) {
        return Request.get(`/admin/user/${userId}/disable`);
    },
    /**
     * 重置密码
     * @param {} userId
     * @returns
     */
    resetPwd(userId) {
        return Request.get('/admin/user/resetPwd', { userId: userId });
    },
    /**
     * 设置前端展示
     * @param {} userId
     * @returns
     */
    shownInFront(userId) {
        return Request.get(`/admin/user/${userId}/showInFront/true`);
    },
    /**
     * 取消前端展示
     * @param {} userId
     * @returns
     */
    cancelShownInFront(userId) {
        return Request.get(`/admin/user/${userId}/showInFront/false`);
    },
    /**
     * 导出用户
     * @param {} data
     * @returns
     */
    exportUser(roleId, data) {
        return Request.post(`/admin/common/export`, {
            url: `/admin/user/search/${roleId}`,
            method: 'post',
            title: '用户名单导出数据',
            headerLabels: ['姓名', '用户名', '手机号', '身份证号',  'Email', 'QQ', '微信号', '总登录次数', '创建时间', '上次登录时间'],
            headerPropertyNames: ['name', 'username', 'phone', 'certificate', 'no', 'email', 'qq', 'weixin', 'totalLoginTimes', 'createDate', 'lastLoginTime'],
            reqData: data
        });
    },

    /**
     * 更改用户密码
     * @param {*} userId
     * @param {*} newpwd
     * @param {*} confirmpwd
     * @returns
     */
    changeUserPwd(userId, newpwd, confirmpwd) {
        return Request.get(`/admin/user/${userId}/changePwd`, {
            newpwd: newpwd,
            confirmpwd: confirmpwd
        });
    },

    /**
     * 向用户发送邮件验证Email
     * @param {} userId
     */
    sendPwdResetEmail(userId) {
        return Request.get(`/admin/user/${userId}/sendPwdResetEmail`);
    },

    /**
     * 向用户发送邮箱验证邮件
     * @param {*} userId
     * @returns
     */
    sendVerifyEmail(userId) {
        return Request.get(`/admin/user/${userId}/sendVerifyEmail`);
    },
    /**
     * 导入用户
     * @returns
     */
    importUsers(identity, params) {
        return Request.post(`/admin/user/${identity}/import`, params);
    },

    /**
     * 获取用户角色
     */
    getUserRoles(userId) {
        return Request.get(`/admin/user/${userId}/roles`);
    },

    /**
     * 为用户分配角色
     * @param {*} userId
     * @param {*} rolesArray
     * @param {*} siteId
     * @param {*} onlyAllowOneRole
     * @param {*} tobeRemovedRoleIds
     * @returns
     */
    assignUserRoles(userId, rolesArray, tobeRemovedRoleIds) {
        var data = {
            rolesArray: rolesArray,
            roleIdsTobeRemoved: tobeRemovedRoleIds
        };
        return Request.post(`/admin/user/${userId}/assignRoles`, data);
    },
    /**
     * 获取yoghurt明细信息
     * @param {*} userId
     * @returns
     */
    getUserDetail(userId) {
        return Request.get(`/admin/userDetail/uid/${userId}`);
    },
    saveUserDetail(userDetail) {
        return Request.post(`/admin/userDetail/save`, userDetail);
    },
    /**
     * 发消息
     */
    sendMessage(messageTypes, api, queryParams, idPropertyName, receivers, title, messageContent, isPrivate) {
        return Request.post('/admin/user/sendMessage', {
            messageTypes: messageTypes,
            api: api,
            queryParams: queryParams,
            idPropertyName: idPropertyName,
            receivers: receivers,
            title: title,
            messageContent: messageContent,
            isPrivate: isPrivate
        });
    },
    /**
     * 查询用户
     * @param {} userIdentity
     * @param {*} query
     * @returns
     */
    fr_search(userIdentity, query) {
        return Request.post(`/admin/user/fr/search/${userIdentity}`, query);
    },
    /**
     * 添加到关注
     * @param {} targetUserId
     */
    attentionTo(targetUserId) {
        return Request.get(`/admin/user/attention/attentionTo/${targetUserId}`);
    },

    /**
     * 取消关注
     * @param {*} targetUserId
     */
    cancelAttention(targetUserId) {
        return Request.get(`/admin/user/attention/attentionTo/${targetUserId}`);
    },

    /**
     * 检查是否已关注了
     * @param {} params
     */
    isAttentions(userIdArray) {
        return Request.post('/admin/user/attention/isAttention', userIdArray);
    },

    /**
     * 查询一个用户的粉丝
     * @param {} userId
     * @param {*} query
     * @returns
     */
    findUserFans(userId, query) {
        return Request.post(`/admin/user/${userId}/findUserFans?lvl=LV3`, query);
    },
    /**
     * 查询一个用户的爱豆
     * @param {*} userId
     * @param {*} query
     * @returns
     */
    findUserIdols(userId, query) {
        return Request.post(`/admin/user/${userId}/findUserIdols?lvl=LV3`, query);
    },
    /**
     * 查询一个用户的粉丝
     * @param {} userId
     * @param {*} query
     * @returns
     */
    fr_myFans(query) {
        return Request.post(`/admin/user/fr_myFans?lvl=LV3`, query);
    },
    /**
     * 查询一个用户的爱豆
     * @param {*} userId
     * @param {*} query
     * @returns
     */
    fr_myIdols(query) {
        return Request.post(`/admin/user/fr_myIdols?lvl=LV3`, query);
    }
};
export default UserAPI;
